import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Print from 'vue-print-nb'
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(Print)

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'YOUR_API_KEY', // 替换为你自己的谷歌地图 API 密钥
    libraries: 'places', // 如果需要使用地点搜索功能，可以添加 'places' 库
  },
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');